//メッセージボックス用定数
export const MSGBOX_TYPE_ERROR = "error";
export const MSGBOX_TYPE_INFO = "info";
export const MSGBOX_TYPE_CAUTION = "caution";
export const MSGBOX_TYPE_SUCCESS = "success";

//引数
interface IFProps {
    args: {type:string, text:string}
}

export function MessageBox(props:IFProps): JSX.Element{

    if (props.args.text){
        return (
            <div className={"msgbox " + props.args.type}>{props.args.text}</div>
        )
    } else {
        return <></>
    }

}